import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import { DiscountQuantityWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { initializeWidget } from "../../../api/initials";
import { setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { mpClickCreateWidgetButton } from "../../../utils/mixpanel";
import { WidgetDrawer } from "../WidgetDrawer/WidgetDrawer";

import { DiscountQuantityWidgetPreview } from "./DiscountQuantityWidgetPreview";

interface QuantityWidgetsOverviewProps {
  quantityWidgets: DiscountQuantityWidget[];
}

export const DiscountQuantityWidgetsOverview = ({
  quantityWidgets,
}: QuantityWidgetsOverviewProps) => {
  const dispatch = useDispatch();

  const onCreateNew = () => {
    mpClickCreateWidgetButton("quantityButtons");
    dispatch(
      setSelectedWidget(
        initializeWidget(
          "quantityButtons",
          "quantityButtonsWidget1"
        ) as DiscountQuantityWidget
      )
    );
    dispatch(setDrawer({ drawer: "widgetAction", open: true }));
  };

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item>
        <IgButton
          variant={"contained"}
          onClick={() => {
            onCreateNew();
          }}
        >
          Create Button
        </IgButton>
      </Grid>
      <Grid item container direction={"row"} rowSpacing={2} columnSpacing={2}>
        {quantityWidgets.map((quantityWidget, index) => (
          <DiscountQuantityWidgetPreview
            key={`quantity-widget-${index}`}
            quantityWidget={quantityWidget}
          />
        ))}
        <WidgetDrawer
          widgetType={"quantityButtons"}
          buttonFocus={"quantityButtons"}
        />
      </Grid>
    </Grid>
  );
};
